import 'babel-polyfill'
import Vue from 'vue'
import './plugins/axios'
import './plugins/vuetify'
import App from './App.vue'
import VueRouter from 'vue-router';
import VueScrollTo from 'vue-scrollto'

Vue.use(VueRouter);
Vue.use(VueScrollTo);

import Win from './components/Win.vue'
import Faq from './components/Faq.vue'
import How from './components/How.vue'
import Home from './components/Home.vue'
import Late from './components/Late.vue'
import Soon from './components/Soon.vue'
import Terms from './components/Terms.vue'
import Thanks from './components/Thanks.vue'
import Privacy from './components/Privacy.vue'
import NotFound from './components/NotFound.vue'

import 'vue-material-design-icons/styles.css';

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: '/',
      name: 'Enter Below',
      component: Home,
      nav: true
    },
    {
      path: '/terms',
      name: 'Terms & Conditions',
      component: Terms,
      nav: true
    },
    {
      path: '/faq',
      name: 'FAQS',
      component: Faq,
      nav: true
    },
    {
      path: '/privacy',
      name: 'Privacy Policy',
      component: Privacy,
      nav: true
    },
    {
      path: '/win',
      name: "You're a winner!",
      component: Win,
      nav: true
    },
    {
      path: '/thanks',
      name: 'Thanks for entering',
      component: Thanks,
      nav: true
    },
    {
      path: '/soon',
      name: 'Coming soon',
      component: Soon,
      nav: true
    },
    {
      path: '/late',
      name: 'Campaign closed',
      component: Late,
      nav: true
    },
    {
      path: '/how',
      name: 'How to enter',
      component: How,
      nav: true
    },
    {
      path: '*',
      name: '404 Error',
      component: NotFound,
      nav: true
    }
  ],
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
